import moment from "moment";
import { useState } from "react";
import { padNumber } from "../utils";

const useDate = (props) => {

    const [date, setDate] = useState(new Date);
    const formatDate = (date) => {
        if (date) {
            date = new Date(date);
            return {
                year: date.getFullYear(),
                month: padNumber(date.getMonth() + 1, 2),
                day: padNumber(date.getDate(), 2)
            };
        } else {
            return null;
        }
    };

    // const GetCalendarMatrixOriginal = ({ date = new Date(), full = false } = {}) => {
    //     date = new Date(date);
    //     const year = date.getFullYear();
    //     const month = date.getMonth();

    //     const daysInMonth = new Date(year, month + 1, 0).getDate();
    //     const firstDay = new Date(year, month, 1).getDay();
    //     const prevMonthDays = new Date(year, month, 0).getDate();

    //     const matrix = [];
    //     let day = 1;
    //     let nextMonthDay = 1;
    //     const dayOrderMap = {};

    //     for (let i = 0; i < 6; i++) {
    //         const week = Array.from({ length: 7 }, (_, j) => {
    //             let cell;
    //             let currentMonth = month;
    //             let currentYear = year;
    //             let dayValue;
    //             let isCurrentMonth = true;

    //             if (i === 0 && j < firstDay) {
    //                 // Previous month's days
    //                 dayValue = prevMonthDays - firstDay + j + 1;
    //                 currentMonth = month - 1;
    //                 isCurrentMonth = false;
    //                 if (currentMonth < 0) {
    //                     currentMonth = 11;
    //                     currentYear -= 1;
    //                 }
    //             } else if (day <= daysInMonth) {
    //                 // Current month's days
    //                 dayValue = day++;
    //             } else {
    //                 // Next month's days
    //                 dayValue = nextMonthDay++;
    //                 currentMonth = month + 1;
    //                 isCurrentMonth = false;
    //                 if (currentMonth > 11) {
    //                     currentMonth = 0;
    //                     currentYear += 1;
    //                 }
    //             }

    //             const weekDay = j; // Sunday = 0, Monday = 1, ..., Saturday = 6
    //             if (isCurrentMonth) {
    //                 if (!dayOrderMap[weekDay]) {
    //                     dayOrderMap[weekDay] = 1;
    //                 } else {
    //                     dayOrderMap[weekDay] += 1;
    //                 }
    //             }

    //             cell = {
    //                 day: dayValue,
    //                 month: currentMonth + 1,
    //                 year: currentYear,
    //                 dayPosition: j + 1,
    //                 weekPosition: i + 1,
    //                 dayOrder: isCurrentMonth ? dayOrderMap[weekDay] : null
    //             };

    //             return cell;
    //         });

    //         matrix.push(week);
    //     }

    //     // Remove the last row if all days belong to the next month
    //     const lastRow = matrix[matrix.length - 1];
    //     if (lastRow.every((d) => d.month === month + 2 || d.month === 1 && month === 11)) {
    //         matrix.pop();
    //     }

    //     // If `full` is false, return only the current week
    //     if (!full) {
    //         const today = date.getDate();
    //         return matrix.filter((week) => week.some((d) => d.month === month + 1 && d.day === today));
    //     }

    //     return matrix;
    // };

    const GetCalendarMatrix = ({ date = new Date(), pointDate = new Date(), full = false } = {}) => {
        date = new Date(date);
        pointDate = new Date(pointDate);
        const year = date.getFullYear();
        const month = date.getMonth();
        const startYear = pointDate.getFullYear();
        const startMonth = pointDate.getMonth();
        const startDay = pointDate.getDate();

        const daysInMonth = new Date(year, month + 1, 0).getDate();
        const firstDay = new Date(year, month, 1).getDay();
        const prevMonthDays = new Date(year, month, 0).getDate();

        const matrix = [];
        let day = 1;
        let nextMonthDay = 1;
        const dayOrderMap = {};

        for (let i = 0; i < 6; i++) {
            const week = Array.from({ length: 7 }, (_, j) => {
                let cell;
                let currentMonth = month;
                let currentYear = year;
                let dayValue;
                let isCurrentMonth = true;
                let includeMeta = true;

                if (i === 0 && j < firstDay) {
                    // Previous month's days
                    dayValue = prevMonthDays - firstDay + j + 1;
                    currentMonth = month - 1;
                    isCurrentMonth = false;
                    includeMeta = false;
                    if (currentMonth < 0) {
                        currentMonth = 11;
                        currentYear -= 1;
                    }
                } else if (day <= daysInMonth) {
                    // Current month's days
                    dayValue = day++;
                    includeMeta = currentYear > startYear || (currentYear === startYear && (currentMonth > startMonth || (currentMonth === startMonth && dayValue >= startDay)));
                } else {
                    // Next month's days
                    dayValue = nextMonthDay++;
                    currentMonth = month + 1;
                    isCurrentMonth = false;
                    if (currentMonth > 11) {
                        currentMonth = 0;
                        currentYear += 1;
                    }
                }

                const weekDay = j; // Sunday = 0, Monday = 1, ..., Saturday = 6
                if (isCurrentMonth && includeMeta) {
                    if (!dayOrderMap[weekDay]) {
                        dayOrderMap[weekDay] = 1;
                    } else {
                        dayOrderMap[weekDay] += 1;
                    }
                }

                cell = {
                    day: dayValue,
                    month: currentMonth + 1,
                    year: currentYear,
                };

                if (includeMeta) {
                    cell.dayPosition = j + 1;
                    cell.weekPosition = i + 1;
                    cell.dayOrder = isCurrentMonth ? dayOrderMap[weekDay] : null;
                }

                return cell;
            });

            matrix.push(week);
        }

        // Remove the last row if all days belong to the next month
        const lastRow = matrix[matrix.length - 1];
        if (lastRow.every((d) => d.month === month + 2 || d.month === 1 && month === 11)) {
            matrix.pop();
        }

        // If `full` is false, return only the current week
        if (!full) {
            return matrix.filter((week) => week.some((d) => d.month === month + 1 && d.day === startDay));
        }

        return matrix;
    };

    const GetCalendarMatrixV2 = (plan, startDate) => {
        if (!plan || typeof plan !== 'object' || !startDate) {
            return null;
        }

        const start = new Date(startDate);
        if (isNaN(start.getTime())) {
            return null;
        }

        let firstScheduleDate = null;

        // Find the date of the first schedule after the start date
        for (let week = 1; week <= 4; week++) {
            if (!plan?.[week]) continue;

            for (let day in plan?.[week]) {
                const dayInt = parseInt(day);
                if (isNaN(dayInt)) continue;

                const currentDate = new Date(start);
                currentDate.setDate(start.getDate() + (week - 1) * 7 + (dayInt - start.getDay()));

                if (currentDate >= start && (!firstScheduleDate || currentDate < firstScheduleDate)) {
                    firstScheduleDate = new Date(currentDate);
                }
            }
        }

        if (!firstScheduleDate) return { calendar: [], startDate: null, endDate: null, dateAfterEndDate: null };

        // Adjust firstScheduleDate to the start of the week (Sunday)
        const calendarStartDate = new Date(firstScheduleDate);
        calendarStartDate.setDate(calendarStartDate.getDate() - calendarStartDate.getDay());

        const result = [];

        // Generate up to 5 weeks, but stop if no more schedules are found
        let lastScheduleDate = null, counter = {}, highlights = {}, temp = {};
        for (let week = 0; week < 5; week++) {
            const weekArray = [];
            let hasSchedule = false;

            for (let day = 0; day < 7; day++) {
                const currentDate = new Date(calendarStartDate);
                currentDate.setDate(calendarStartDate.getDate() + week * 7 + day);

                const dayObject = {
                    day: currentDate.getDate(),
                    month: currentDate.getMonth() + 1,
                    year: currentDate.getFullYear(),
                };

                const weekIndex = Math.floor((currentDate - firstScheduleDate) / (7 * 24 * 60 * 60 * 1000)) + 1;
                const schedule = plan?.[weekIndex]?.[day] || null;
                if (schedule && schedule?.program?.id) {
                    counter = {
                        ...counter,
                        [schedule?.program?.id]: counter?.[schedule?.program?.id] ? (counter?.[schedule?.program?.id] + 1) : 1,
                    }
                    temp = {
                        ...schedule,
                        program: {
                            ...schedule?.program,
                            occurence: counter[schedule?.program?.id],
                        }
                    };
                    highlights[`${dayObject?.year}-${dayObject?.month}-${dayObject?.day}`] = { ...temp };
                    dayObject.schedule = { ...temp };
                    hasSchedule = true;
                    lastScheduleDate = new Date(currentDate);
                }

                weekArray.push(dayObject);
            }

            result.push({ weekArray, hasSchedule });
        }

        // Remove trailing weeks with no schedules after the last scheduled day
        while (result.length > 0 && !result?.[result.length - 1]?.hasSchedule) {
            result.pop();
        }

        const calendar = result.map(({ weekArray }) => weekArray);
        const endDate = lastScheduleDate ? new Date(lastScheduleDate) : null;
        const dateAfterEndDate = endDate ? new Date(endDate) : null;
        if (dateAfterEndDate) dateAfterEndDate.setDate(dateAfterEndDate.getDate() + 1);

        return {
            calendar,
            highlights: { ...highlights },
            startDate: formatDate(firstScheduleDate),
            endDate: formatDate(endDate),
            dateAfterEndDate: formatDate(dateAfterEndDate),
        };
    }

    const GetMonthDates = (date = new Date()) => {
        const year = date.getFullYear();
        const month = date.getMonth();
        const day = date.getDate();
        const week = date.getDay();
        const endDate = moment(new Date(year, month + 1, 0)).format("MM/DD/YY");
        const startDate = moment(new Date(year, month, 1)).format("MM/DD/YY");
        return { startDate, endDate, year, month: month + 1, day, week };
    }

    const GetCurrentDay = () => {
        return date?.getDate();
    }

    const GetWeekOfMonth = (date = new Date()) => {
        const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
        const firstDayWeekday = firstDay.getDay(); // Day of the week (0 = Sunday, 1 = Monday, ..., 6 = Saturday)

        // Adjust for weeks starting on Monday (ISO week start)
        const offset = (firstDayWeekday === 0 ? 6 : firstDayWeekday - 1); // Convert Sunday to last day of previous week

        return Math.ceil((date.getDate() + offset) / 7);
    }

    const GetWeekDetails = (date = new Date(), pointDate = new Date()) => {
        const dayOfWeek = date.getDay(); // 0 (Sunday) - 6 (Saturday)
        const dayOfMonth = date.getDate();

        pointDate = new Date(pointDate);
        const pdDayOfMonth = pointDate.getDate();


        // Get the first day of the month
        const firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1).getDay();

        // Calculate the week position in the month
        const weekPosition = Math.ceil((dayOfMonth + firstDayOfMonth) / 7);

        // Calculate the day order (e.g., 1st Sunday, 2nd Monday, etc.)
        const dayOccurrences = Math.floor((pdDayOfMonth - 1) / 7) + 1;

        return {
            dayPosition: dayOfWeek + 1, // 1 (Sunday) - 7 (Saturday)
            weekPosition,
            dayOrder: dayOccurrences
        };
    };



    const GetToday = () => {
        const today = formatDate(new Date());
        return {
            ...today,
            key: `${today.year}-${today.month}-${today.day}`,
            ...GetWeekDetails()
        }
    }

    return {
        GetToday,
        GetCalendarMatrix,
        GetCalendarMatrixV2,
        GetMonthDates,
        GetCurrentDay,
        GetWeekOfMonth,
        GetWeekDetails,
    };
};

export default useDate;
